import { useEffect, useState } from 'react';

/**
 * Trails `value` by `delay` ms.
 *
 * Search now goes over the network on every keystroke, and `service.search_items`
 * does a `LIKE` scan per list the caller can see — so the input keeps its own
 * immediate state and only the *query* is debounced. React Query dedupes and
 * caches per term on top of this.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
